module.exports = __webpack_public_path__ + "static/media/testimonial-image-02.78f08b89.png";